import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegram, faDiscord, faYoutube } from "@fortawesome/free-brands-svg-icons";
import {Container, Row, Col} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './main.scss';
import ww_logo from "../../images/logo/logogr.png";


function Footer() {
    return (
        <div className="App">
            <footer>
                <Container>
                    <Row>
                        <Col xs={12} sm={6}>
                            <h3>Join our community</h3>
                            <div className="social-container">
                                <a href="https://twitter.com/EverdreamSoft" target="_blank"
                                   className="social" rel="noreferrer">
                                    <FontAwesomeIcon icon={faTwitter} size="2x" />
                                </a>
                                <a href="https://t.me/EverdreamSoft" target="_blank"
                                   className="social" rel="noreferrer">
                                    <FontAwesomeIcon icon={faTelegram} size="2x" />
                                </a>
                                <a href="https://www.youtube.com/user/Everdreamsoft" target="_blank"
                                   className="social" rel="noreferrer">
                                    <FontAwesomeIcon icon={faYoutube} size="2x" />
                                </a>
                                <a href="https://discord.com/invite/H4UXSaJ" target="_blank"
                                   className="social" rel="noreferrer">
                                    <FontAwesomeIcon icon={faDiscord} size="2x" />
                                </a>
                            </div>
                        </Col>
                        <Col xs={12} sm={6}>
                            <h3>Stay updated</h3>
                            <p>Join our mailing list to stay updated with our newest features.</p>
                            <form>
                                <input type="email" id="email" name="email" placeholder="Enter your email address"/>
                                <input type="submit" className="btn-grad" value="Sign up" />
                            </form>
                        </Col>
                    </Row>
                    <hr/>
                    <Row>
                        <Col xs={12} sm={6}>
                            <img src={ww_logo} alt="Logo" />
                            <p>Decentralized certification authority for tokenized assets.</p>
                        </Col>
                        <Col  xs={12} sm={3}>
                            <h3>Site map</h3>
                            <p><ul>
                                <li><a href="/About">About</a></li>
                                <li><a href="/MyWallet">My wallet</a></li>
                                <li><a href="/Collections">Assets</a></li>
                                <li><a href="/faq">FAQ</a></li>
                            </ul></p>
                        </Col>
                        <Col  xs={12} sm={3}>
                            <h3>Company</h3>
                            <p><a href="https://everdreamsoft.com/" target="_blank">EverdreamSoft</a></p>
                        </Col>
                    </Row>
                    <hr/>
                    <Row>
                        <Col className="ft-credit">
                            <p>© {new Date().getFullYear()} EverdreamSoft</p>
                        </Col>
                        <Col className="ft-legal">
                            <p><a href="" target="_blank">Terms of service</a> | <a href="" target="_blank">Privacy Policy</a></p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
    );
}

export default Footer;
